import React from 'react';
import { useDispatch } from 'react-redux';

import { Closing } from 'services/action';
import { Page } from 'ui/components';
import {
  Action,
  DetailDocument,
  Coaes,
} from './component/detail';

const initialState = {
  data: null,
};

const DetailScreen = ({ match }) => {
  const Dispatch = useDispatch();

  const [{ data }, setState] = React.useState(initialState);

  const $onLoad = async (e) => {
    const req = await Dispatch(Closing.$show(e));

    if (req?.message === 'success') {
      setState((prevState) => ({ ...prevState, data: req?.data }));
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  return (
    <Page className="col-12 col-md-8 bordered">
      <Page.Header
        title="Tutup Buku"
        backTo="/accounting/closing"
      >
        <Action data={data} onSubmit={() => $onLoad(match?.params?.id)} />
      </Page.Header>

      <Page.Body className="bg-white border-top padding mt-3 mt-md-0">
        <DetailDocument
          data={data}
        />
        <Coaes data={data} />

      </Page.Body>
    </Page>
  );
};

export default DetailScreen;
